import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import ContractAssetStatusCreateForm from "./create";
import ContractAssetStatusEditForm from "./edit";
import {
  getContractAssetStatusDetails,
  getContractAssetStatuses,
} from "src/store/contract-asset-status/saga";
import {
  ContractAssetStatusDetailDto,
  ContractAssetStatusDto,
} from "src/store/contract-asset-status/type";
const ContractAssetStatusesPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<ContractAssetStatusDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ContractAssetStatusDetailDto>();
  const columns = [
    {
      text: t("Contract.AssetStatus.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Contract.AssetStatus.PageTitle")}
        metaTag={t("Contract.AssetStatus.MetaTag")}
        gridProps={{
          addTitle: t("Contract.AssetStatus.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getContractAssetStatuses,
          // onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getContractAssetStatusDetails({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          // deleteButton: {
          //   text: (id, data: SectorDto) =>
          //     t("Contract.AssetStatus.DeleteQA", {
          //       name: data.Name,
          //     }),
          //   action: deleteSectorSaga,
          //   onClick: (id, data) => setShowEdit(data),
          // },
        }}
      />
      <ContractAssetStatusCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getContractAssetStatuses,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ContractAssetStatusEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getContractAssetStatuses,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ContractAssetStatusesPage;
